<div class="dropleft">
    <button class="border-0 bg-transparent" type="button"  id="dropdownMenuButton"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" matTooltip="{{ 'projectwizard.createanew' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500">
        <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
            add
        </span>
    </button>
    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <p class="dropdown-header text-center text-muted" style="background-color: #f2f2f2;">{{ 'projectwizard.createproject' | trans }}</p>
        <a (click)="setFromTemplate(true)" class="dropdown-item text-center project-hover" data-toggle="modal" [attr.data-target]="'#projectwizard'+dealId">    
            <p class="mb-0 align-middle">{{ 'projectwizard.fromtemplate' | trans }}
               <!-- <button data-toggle="modal" data-target="#projectwizard" class="btn-empty border-0" matTooltip="Create from template" matTooltipPosition="above" matTooltipShowDelay="500"> 
                    <span class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
                        note_add
                    </span>
                </button> -->
            </p>
        </a>
        <a (click)="setFromTemplate(false)" class="dropdown-item text-center project-hover" data-toggle="modal" [attr.data-target]="'#projectwizard'+dealId">    
            <p class="mb-0 align-middle">{{ 'projectwizard.fromblank' | trans }}
                <!-- <button data-toggle="modal" data-target="#projectwizard" class="btn-empty border-0" matTooltip="Create blank" matTooltipPosition="above" matTooltipShowDelay="500"> 
                    <span class="material-icons align-middle portal-icon f-24 lh-35 center btn p-0 rounded-circle w-35 h-35">
                        post_add
                    </span>
                </button> -->
            </p>
        </a>
    </div>
</div>

<div class="modal fade" [id]="'projectwizard'+dealId" tabindex="-1" role="dialog" >
    <div class="modal-dialog modal-lg modal-dialog-centered" [ngClass]="{'modal-dialog-scrollable': assigntoggle || fromtemplate}" role="document">
      <div class="modal-content" [ngClass]="{'min-height-modal': fromtemplate == true}">
        <app-loadconfirm *ngIf="showSpinner" [text]="'projectwizard.saving' | trans " [icon]="'pending'"></app-loadconfirm>
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{ 'projectwizard.Projectcreation' | trans }}</h5>
          <button #closeprojectcreation type="button" (click)="reset()" class="close" data-dismiss="modal" aria-label="Close">
            <span >&times;</span>
          </button>
        </div>
        <div class="modal-body" style="overflow-x: hidden!important;">
            <ng-container *ngIf="showhelp && assigntoggle || tagstoggle">
                <div class="card bg-secondary ml-0 mr-0 p-2 mb-3">
                  <div class="row">
                    <div class="col-auto">
                      <span class="material-icons pl-2">
                        help_outline
                        </span>
                    </div>
                    <div *ngIf="assigntoggle" class="col-10">
                        <p class="mb-0">{{ 'projectassign.assignhelpertext' | trans }} </p>
                    </div>
                    <div *ngIf="tagstoggle" class="col-10">
                        <p class="mb-0">{{ 'projectassign.taghelpertext' | trans }} </p>
                    </div>
                  </div>
                </div>
              </ng-container>
<div *ngIf="project && project.projectId" class="row border-bottom mb-2">
    <div class="col border-right mb-2">
        <a (click)="toggleInfo()">
        <ng-container *ngIf="project && project.projectId && informationtoggle">
            <p class="mb-0 lh-25 align-middle text-center font-weight-bold">{{ 'projectwizard.Information' | trans }}</p>
        </ng-container>
        <ng-container *ngIf="project && project.projectId && !informationtoggle">
            <p class="mb-0 lh-25 align-middle text-center font-weight">{{ 'projectwizard.Information' | trans }}</p>
        </ng-container>
        </a>
    </div>
    <div *ngIf="project && project.projectId" class="col border-right mb-2">
        <a (click)="toggleAssign()">
            <ng-container *ngIf="assigntoggle">
                <p class="mb-0 lh-25 align-middle text-center font-weight-bold">{{ 'projectwizard.Assign' | trans }}</p>
            </ng-container>
            <ng-container *ngIf="!assigntoggle">
                <p class="mb-0 lh-25 align-middle text-center">{{ 'projectwizard.Assign' | trans }}</p>
            </ng-container>
            </a>    </div>
    <div *ngIf="project && project.projectId" class="col mb-2">
        <a (click)="toggleTag()">
            <ng-container *ngIf="tagstoggle">
                <p class="mb-0 lh-25 align-middle text-center font-weight-bold">{{ 'projectwizard.Tags' | trans }}</p>
            </ng-container>
            <ng-container *ngIf="!tagstoggle">
                <p class="mb-0 lh-25 align-middle text-center">{{ 'projectwizard.Tags' | trans }}</p>
            </ng-container>
            </a>    </div>
  </div>
  <ng-container *ngIf="informationtoggle && fromtemplate">
    <app-projecttemplatelist (projecttoadd)="setProject($event)" (templatestep)="templatelistover($event)" (setProjectload)="setProjectload($event)" *ngIf="fromtemplate" [wizard]="true" [dealId]="dealId" [customerId]="customerId"></app-projecttemplatelist>
  </ng-container>
  <ng-container *ngIf="informationtoggle">
    <app-orgprojectadd (projecttoadd)="setProject($event)" (setProjectload)="setProjectload($event)" *ngIf="!project?.projectId && !fromtemplate" [wizard]="true" [dealId]="dealId" [customerId]="customerId"></app-orgprojectadd>
    <app-orgprojectedit (projecttoupdate)="project = $event" [project]="project" *ngIf="project && project.projectId && !fromtemplate" [wizard]="true" [customerId]="customerId"></app-orgprojectedit>
  </ng-container>
  <ng-container *ngIf="assigntoggle">
    <app-projectassign (gotoT)="toggleTag()" (setProjectload)="setProjectload($event)" [project]="project ? project : null" [wizard]="true" [nomodal]="true"></app-projectassign>
  </ng-container>
  <ng-container *ngIf="tagstoggle">
    <app-tagaddremove (tagsloaded)="tagsloaded($event)" [entityId]="project ? project.projectId : null" [tagtype]="'project'" [modalmode]="true" [viewmode]="false" [smalltype]="false"></app-tagaddremove>
  </ng-container>
  <button *ngIf="tagstoggle"  type="button" (click)="closeWizard()" class="btn-save">
    <h6 class="btn-save-text">{{ 'projectwizard.Done' | trans }}</h6>
  </button>
</div>

</div>
</div>
</div>